<app-add-personnel
    *ngIf="!!contact || !!nonOwnerPersonnel"
    [contact]="contact"
    [nonOwnerPersonnel]="nonOwnerPersonnel"
    [isAnOwner]="isAnOwner"
    [contactsSaving]="saving$ | async"
    [nopSaving]="processing$ | async"
    (cancel)="cancel()"
    (saveContact)="saveContact($event)"
    (saveNonOwnerPersonnel)="saveNonOwnerPersonnel($event)"
    (switchOwnershipType)="toggleIsAnOwner($event)">
</app-add-personnel>
